import { useEffect, useState } from "react";
import supabase from "../supabaseClient";

/**
 * Centralized admin auth hook.
 *
 * Returns:
 *   authChecked  – false while the async check is still in-flight
 *   isLoggedIn   – true once a valid session is confirmed
 *   isAdmin      – true when the session's profile has role === "admin"
 */
const useAdminAuth = () => {
	const [authChecked, setAuthChecked] = useState(false);
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	const [isAdmin, setIsAdmin] = useState(false);

	useEffect(() => {
		const checkAuth = async () => {
			const {
				data: { session },
			} = await supabase.auth.getSession();

			if (!session) {
				setIsLoggedIn(false);
				setIsAdmin(false);
				setAuthChecked(true);
				return;
			}

			setIsLoggedIn(true);

			const { data: profile } = await supabase
				.from("profiles")
				.select("role")
				.eq("supabaseId", session.user.id)
				.single();

			setIsAdmin(profile?.role === "admin");
			setAuthChecked(true);
		};

		checkAuth();
	}, []);

	return { authChecked, isLoggedIn, isAdmin };
};

export default useAdminAuth;
